import React from "react";
import { featured } from "../mock";
import { useCart, formatPrice } from "../context/CartContext";
import Stars from "./Stars";
import { Check, ShoppingCart, ShieldCheck } from "lucide-react";
import useReveal from "../hooks/useReveal";

export default function FeaturedProduct() {
  const { addItem } = useCart();
  const ref = useReveal();
  const p = featured;
  return (
    <section className="bg-gray-50 py-16">
      <div ref={ref} className="reveal mx-auto max-w-7xl px-4 lg:px-8">
        <div className="grid items-center gap-8 overflow-hidden rounded-3xl border border-navy/10 bg-white shadow-sm md:grid-cols-2">
          <div className="relative flex items-center justify-center bg-gradient-to-br from-sky/60 to-white p-8 md:p-12">
            <span className="absolute left-5 top-5 rounded-full bg-brand px-3 py-1.5 text-xs font-bold text-white">
              {p.badge}
            </span>
            <img src={p.image} alt={p.name} className="max-h-[380px] w-full object-contain" />
          </div>
          <div className="p-8 md:p-12">
            <p className="mb-2 text-xs font-bold uppercase tracking-[0.2em] text-brand">
              Featured Product
            </p>
            <h2 className="font-heading text-2xl font-extrabold text-navy md:text-3xl">{p.name}</h2>
            <div className="mt-3 flex items-center gap-2">
              <Stars value={p.rating} size={16} />
              <span className="text-sm text-navy/60">{p.rating} ({p.reviews} reviews)</span>
            </div>
            <p className="mt-4 italic text-navy/70">{p.tagline}</p>
            <ul className="mt-5 space-y-2">
              {p.bullets.map((b) => (
                <li key={b} className="flex items-start gap-2 text-sm text-navy/80">
                  <Check size={18} className="mt-0.5 shrink-0 text-brand" /> {b}
                </li>
              ))}
            </ul>
            <div className="mt-6 flex items-baseline gap-3">
              <span className="font-heading text-3xl font-extrabold text-navy">{formatPrice(p.price)}</span>
              <span className="text-lg text-navy/40 line-through">{formatPrice(p.compareAt)}</span>
            </div>
            <div className="mt-6 flex flex-wrap gap-3">
              <button
                onClick={() => addItem({ id: p.id, name: p.name, price: p.price, image: p.image })}
                className="flex items-center gap-2 rounded-full bg-brand px-8 py-3 font-heading font-bold text-white transition-colors hover:bg-brand-dark"
              >
                <ShoppingCart size={18} /> Add to Cart
              </button>
              <span className="flex items-center gap-2 text-sm font-medium text-navy/60">
                <ShieldCheck size={18} className="text-navy" /> Guaranteed for life
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
